import axios from 'axios';
import { secureLogin } from '../../config/apiConfig';
import {
  FETCH_AUTHORIZATION_TOKEN_FAILURE,
  FETCH_AUTHORIZATION_TOKEN_SUCCESS,
  FETCH_AUTHORIZATION_TOKEN_BEGIN,
} from '../constants/authorization';


export const getAuthorizationToken = (EmailId, accessToken) => {

  const data = {
    "ParamValue": accessToken,
    "EmailAddress": EmailId
  };

  return (dispatch) => {
    dispatch(fetchTokenBegin());

    axios.post(`${secureLogin}`, data)
      .then((repos) => {
        const TokenData = repos.data;
        const attribute = repos.data.attribute;
        let operation = {
          isEditable: false,
        };

        if (attribute === 'Viewer') {
          operation = {
            isEditable: false,
          };
        } else if (attribute === 'Admin') {
          operation = {
            isEditable: true,
          };
        } else if (attribute === 'Editor') {
          operation = {
            isEditable: true,
          };
        }

        dispatch(fetchTokenSuccess({ ...TokenData, ...operation }));
        localStorage.setItem('entryKey', TokenData.token);

          return TokenData;
      })
        .catch((error) => {
            dispatch(fetchTokenFailure(error));
            window.location.href = "/";
            localStorage.clear();// Redirect to home page on fetch failure
        });
  };
};

export const fetchTokenBegin = () => ({
  type: FETCH_AUTHORIZATION_TOKEN_BEGIN,
});

export const fetchTokenSuccess = (TokenData) => ({
  type: FETCH_AUTHORIZATION_TOKEN_SUCCESS,
  payload: { TokenData },
});

export const fetchTokenFailure = (errorMessage) => ({
  type: FETCH_AUTHORIZATION_TOKEN_FAILURE,
  payload: { errorMessage }
});

// Implement session management using window.onbeforeunload and window.onload
//window.onbeforeunload = function (e) {
//  window.onunload = function () {
//    localStorage.isMySessionActive = "false";
//  }
//  return undefined;
//};

//window.onload = function () {
//  localStorage.isMySessionActive = "true";
//};

